import { type ReactElement } from "react"

export interface INavSectionsItems {
  to: string
  activePaths: string[]
  label: string
  icon: ReactElement
  target?: string
  isMain?: boolean
  disabled?: boolean
  onClick?: () => void
  loading?: boolean
  testId?: string
}

export interface INavSections {
  id?: string
  title: string
  groups?: string[]
  items: INavSectionsItems[]
}

export enum ProductCategories {
  MAKEUP = "MAKEUP",
  HATS = "HATS",
  GLASSES = "GLASSES",
  SCARVES = "SCARVES",
  JEWELRY = "JEWELRY",
  EARRINGS = "EARRINGS",
  EYE_LENSES = "EYE_LENSES",
  BB_CC_CREAM = "BB_CC_CREAM",
  CC_CREAM = "CC_CREAM",
  BB_CREAM = "BB_CREAM",
  HAIRS = "HAIRS",
}
export enum ProductCategoriesLink {
  MAKEUP = "/products",
  GLASSES = "/glasses",
  HATS = "/hats",
  SCARVES = "/scarves",
  JEWELRY = "/jewelry",
  EARRINGS = "/earrings",
  EYE_LENSES = "/eye-lenses",
  EYELASHES = "/eyelashes",
  BB_CC_CREAM = "/bb-cc-cream",
  CC_CREAM = "/cc-cream",
  BB_CREAM = "/bb-cream",
  HAIRS = "/hairs",
}
